import React, { Fragment } from "react";
import { languageService } from "../../../Language/language.service";
import CustomForm from "../../../libraries/form";
import { StyledButtonActionsTable } from "../../Common/Buttons";
import ThisTable from "../../Common/ThisTable";
import UISectionHeader from "../../Common/UISectionHeader";
import { MultiDayHosGraphicalView } from "../Helper/HosGraphicalView";
import { complianceIssuesWithReasonTableSchema } from "./schemas/complianceIssuesTableSchema";
import { hosCommingledServiceCommentsTableSchema } from "./schemas/hosCommingledServiceCommentsTableSchema";
import { hosCurrentReportingPeriodTableSchema } from "./schemas/hosCurrentReportingPeriodTableSchema";
import { hosPreviouslyServedHoursTableSchema } from "./schemas/hosPreviouslyServedHoursTableSchema";
import { HosGraphicalView } from "../Helper/HosGraphicalView/index_v2";

const AddHosRecordDraftPhase = ({
  timezone,
  hosReportingPeriodDate,
  prevHosRecords,
  currentHosRecords,
  commingledRecords,
  latestHosRecord,
  effectiveDate,
  openCreateHosEntryForm = () => {},
  openEditOrDeleteHosEntryForm = () => {},
}) => {
  const reportingPeriodLength = currentHosRecords.length;
  const prevViolations = prevHosRecords
    .filter((record) => Array.isArray(record.violations) && record.violations.length > 0)
    .map((record) =>
      record.violations.map((violation) => ({
        startDate: record.startDate,
        endDate: record.endDate,
        timezone: record.timezone,
        issueText: violation.issueText,
        reason: violation.reason,
      })),
    )
    .flat();
  return (
    <Fragment>
      <UISectionHeader title={languageService("Previously Served Hours")} />
      <ThisTable
        tableColumns={hosPreviouslyServedHoursTableSchema}
        tableData={prevHosRecords}
        pagination={false}
        forDashboard={false}
        height={"auto"}
        onClickSelect
      />
      {prevViolations.length !== 0 ? (
        <Fragment>
          <UISectionHeader title={languageService("Violations")} />
          <ThisTable
            tableColumns={complianceIssuesWithReasonTableSchema}
            tableData={prevViolations}
            pagination={false}
            forDashboard={false}
            height={"auto"}
            onClickSelect
          />
        </Fragment>
      ) : null}
      <UISectionHeader
        title={languageService("Current Reporting Period")}
        addPermission={true}
        addButtonTitle={languageService("Add HOS Entry")}
        addCallback={openCreateHosEntryForm}
      />
      <ThisTable
        tableColumns={[
          ...hosCurrentReportingPeriodTableSchema,
          {
            Header: languageService("Actions"),
            id: "actions",
            Cell: (d) => {
              const index = d.row._index;
              const lastEntry = index + 1 === reportingPeriodLength;
              // TODO: Check for permission
              //   /**permissionCheck("MAINTENANCE", "view") */ true &&

              return (
                <div>
                  <StyledButtonActionsTable
                    title={languageService("Edit")}
                    onClick={() => openEditOrDeleteHosEntryForm(index, lastEntry ? "edit" : "partialEdit")}
                  />
                  {lastEntry ? (
                    <StyledButtonActionsTable
                      title={languageService("Delete")}
                      onClick={() => openEditOrDeleteHosEntryForm(index, "delete")}
                    />
                  ) : null}
                </div>
              );
            },
            minWidth: 275,
          },
        ]}
        tableData={currentHosRecords}
        pagination={false}
        forDashboard={false}
        height={"auto"}
        onClickSelect
      />

      {/* <MultiDayHosGraphicalView
        // Previous and Current HOS records are passed to that we can display prev data as well (if existing in the first day)
        reportingPeriod={[...prevHosRecords, ...currentHosRecords]}
        timezone={timezone}
        viewStartDate={hosReportingPeriodDate}
        addMode={true}
      /> */}
      <HosGraphicalView
        records={[...prevHosRecords, ...currentHosRecords]}
        timezone={timezone}
        viewStartDate={hosReportingPeriodDate}
        displayMode={"ADD"}
        latestHosRecord={latestHosRecord}
        effectiveDate={effectiveDate}
      />

      {commingledRecords.length !== 0 ? (
        <Fragment>
          <UISectionHeader title={languageService("Commingled Service Comments")} />
          <ThisTable
            tableColumns={hosCommingledServiceCommentsTableSchema}
            tableData={commingledRecords}
            pagination={false}
            forDashboard={false}
            height={"auto"}
            onClickSelect
          />
        </Fragment>
      ) : null}
    </Fragment>
  );
};

export default AddHosRecordDraftPhase;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/MyHoursOfService/AddHosRecordDraftPhase.jsx